import { SimpleGrid } from "@chakra-ui/react";
import { IconType } from "common";
import { AppIcon } from "./AppIcon";

interface AppIconListProps {
  selectedIconType: IconType;
  setSelectedIconType: (t: IconType) => void;
}

export const AppIconList = ({
  selectedIconType,
  setSelectedIconType,
}: AppIconListProps) => {
  return (
    <SimpleGrid
      minChildWidth={"100px"}
      spacing={4}
      width={"100%"}
      paddingTop={4}
    >
      {Object.values(IconType).map((iconType) => (
        <AppIcon
          key={iconType}
          type={iconType}
          size={75}
          selected={iconType === selectedIconType}
          onClick={() => setSelectedIconType(iconType)}
          borderRadius={4}
        />
      ))}
    </SimpleGrid>
  );
};
